module.exports = __webpack_public_path__ + "static/img/create-account-form.eea65254.svg";